import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const NotScheduledAIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M4.88571 3.85714L4.88567 0.771427M13.1143 3.85714L13.1142 0.771427M0.77142 7.97141L0.771426 16.2C0.771427 16.768 1.23193 17.2285 1.8 17.2285H16.2C16.768 17.2285 17.2285 16.768 17.2285 16.2L17.2285 7.97141M0.77142 7.97141L0.771449 4.8857C0.771454 4.31764 1.23196 3.85714 1.80002 3.85714H16.2C16.7681 3.85714 17.2286 4.31765 17.2286 4.88572L17.2285 7.97141M0.77142 7.97141H17.2285M11.0571 12.6C11.0571 13.7361 10.1361 14.6571 8.99995 14.6571C7.86383 14.6571 6.94281 13.7361 6.94281 12.6C6.94281 11.4639 7.86383 10.5428 8.99995 10.5428C10.1361 10.5428 11.0571 11.4639 11.0571 12.6Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

NotScheduledAIcon.displayName = 'NotScheduledAIcon';
